<template>
  <div>
    <b-card>
      <b-form>
        <b-row>
          <b-col>
            <b-form-group
              class="mr-3 ml-3"
              label="دپارتمان"
              label-class="mr-3"
              label-align="left"
              label-for="input_department_name"
            >
              <b-form-input
                id="input_department_name"
                v-model="newDepartment.name"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="des-gr" label="وضعیت:" label-for="des">
              <MDDropdown
                v-bind:group="113"
                v-model="newDepartment.mdid113_department_status"
              ></MDDropdown>
            </b-form-group>
          </b-col>
          <b-col></b-col>
          <b-col></b-col>
        </b-row>
        <b-button variant="success" @click="addDepartment">ذخیره</b-button>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import MDDropdown from "../../components/MDDropdown";

export default {
  name: "addDepartment",
   components: {
    MDDropdown,
  },
  data: function () {
    return {
      newDepartment: {
        name: null,
        role_ids: "1,2,3",
        mdid113_department_status: null,
      },
    };
  },
  methods: {
    addDepartment: function () {
      httpHelper.setAuth();
      httpHelper
        .postData("departments", this.newDepartment)
        .then((response) => {
          if (response.success === true) {
            this.$makeToast('success','ایجاد دپارتمان',"دپارتمان جدید با موفقیت ایجاد شد",5000)
          }
          this.$router.push("/rp/3");
        })
        .catch((error) => {})
        .finally(() => {});
    },
  },
  created() {},
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "دپارتمان های تیکت",
        route: "/rp/3",
      },
      {
        title: "دپارتمان جدید",
      },
    ]);
  },
};
</script>